import { apiClient } from "shared/utils";
import { GetRegainExportRequest, GetRegainExportResponse } from "api/models";

export const getRegainExport = async ({ shopId, exportId }: GetRegainExportRequest) => {
  const { data } = await apiClient.get<GetRegainExportResponse>(
    `/${shopId}/dashboard/regains/exports/${exportId}`,
    {
      params: {
        exportId
      }
    }
  );

  return data;
};
